$(document).ready(function() {
  $('.project-card-cover').on('click', function(e) {
    if (!$(e.target).is('.project-card-link')) {
      $(this).find('.project-card-link')[0].click();
    }
  });
});
